<template>
    <div>
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving_file">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file, please wait
                </div>
            </div>
        </div>
        <div class="box" v-if="!loading">
            <div class="box-content">
                <div class="form-group">
                    <label>Current Item:</label>
                    <div class="flex">
                        <div>
                            <img :src="`${$aws_bucket_url}${current_thumbnail_url}`">
                        </div>
                        <div class="p-6 flex flex-col justify-around">
                            <a class="btn-primary" @click="downloadItem(keystone_marketing_download.id)">
                                <strong>Download</strong>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="flex-2xs">
                    <div class="half-width-2xs pr-3-2xs">
                      <div class="form-group flex flex-col">
                        <label>Upload File</label>
                        <form :action="`${$aws_upload_url}`" method="post"
                              enctype="multipart/form-data" id="amazon_form">
                          <input type="hidden" name="policy" :value="aws_policy">
                          <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                          <input type="hidden" name="x-amz-credential" :value="aws_credential">
                          <input type="hidden" name="x-amz-date" :value="aws_date">
                          <input type="hidden" name="x-amz-signature" :value="aws_signature">
                          <input type="hidden" name="acl" value="private">
                          <input type="hidden" name="Content-Type" v-model="filetype">
                          <input type="hidden" name="key" v-model="keystone_marketing_download.filename">
                        </form>
                        <vue-dropzone
                          ref="fileUploadDropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAddedToDropZone"
                          v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                          :useCustomSlot="true"
                        >
                          <div>
                            <div class="mb-3">
                              DRAG AND DROP FILE
                            </div>
                            <div class="mb-3">
                              OR
                            </div>
                            <div>
                              <a class="btn-secondary-outline">
                                Choose a file
                              </a>
                            </div>
                          </div>
                        </vue-dropzone>
                      </div>
                      <div class="form-group mb-0-2xs flex flex-col">
                        <label>Upload Thumbnail</label>
                        <form :action="`${$aws_upload_url}`" method="post"
                              enctype="multipart/form-data" id="thumbnail_amazon_form">
                          <input type="hidden" name="policy" :value="aws_policy">
                          <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                          <input type="hidden" name="x-amz-credential" :value="aws_credential">
                          <input type="hidden" name="x-amz-date" :value="aws_date">
                          <input type="hidden" name="x-amz-signature" :value="aws_signature">
                          <input type="hidden" name="acl" value="private">
                          <input type="hidden" name="Content-Type" v-model="thumbnail_upload.filetype">
                          <input type="hidden" name="key" v-model="thumbnail_upload.filename">
                        </form>
                        <vue-dropzone
                          ref="thumbnailFileUploadDropzone"
                          id="thumbnail_dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="thumbnailFileAddedToDropZone"
                          v-on:vdropzone-removed-file="thumbnailFileRemovedFromDropZone"
                          :useCustomSlot="true"
                        >
                          <div>
                            <div class="mb-3">
                              DRAG AND DROP FILE
                            </div>
                            <div class="mb-3">
                              OR
                            </div>
                            <div>
                              <a class="btn-secondary-outline">
                                Choose a file
                              </a>
                            </div>
                          </div>
                        </vue-dropzone>
                      </div>
                    </div>
                    <div class="half-width-2xs pl-3-2xs">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" v-model="keystone_marketing_download.name" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="align-right mt-3">
                    <a class="btn-primary" @click.prevent="save()">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone';
  import VideoEmbed from "../VideoEmbed";

  export default {
    props: [
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
      'keystone_marketing_download_prop',
    ],
    components: {
      'vue-dropzone': vue2Dropzone,
      VideoEmbed,
    },
    data() {
      return {
        keystone_marketing_download: {},
        current_thumbnail_url: '',
        loading: true,
        filename: '',
        filetype: '',
        saving_file: false,
        uploaded_file: null,
        dropzoneOptions: {
          url: '/',
          autoProcessQueue: false,
          uploadMultiple: true,
          addRemoveLinks: true,
        },
        thumbnail_upload_uploaded_file: null,
        thumbnail_upload: {
          filetype: '',
          filename: '',
          thumbnail_url: '',
        },
      };
    },
    async mounted() {
      this.keystone_marketing_download = this.keystone_marketing_download_prop;
      this.current_thumbnail_url = this.keystone_marketing_download.thumbnail_url;
      this.loading = false;
    },
    methods: {
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.'+extension, '');

        if (this.keystone_marketing_download.name !== '') {
          this.keystone_marketing_download.name = original_file_name;
        }

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp', 'tif', 'pdf', 'zip', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'mp4',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: jpg, png, svg, gif, bmp, tif, pdf, xls, doc, ppt, mp4',
          });
          return;
        }

        if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'keystone_marketing_downloads/'+ original_file_name + '_' + Date.now();
        this.keystone_marketing_download.filename = filename + '.' + extension;

        if(extension.toLowerCase() === 'svg') {
          this.keystone_marketing_download.thumbnail_url = this.keystone_marketing_download.filename;
        } else {
          this.keystone_marketing_download.thumbnail_url = 'thumbnails/' + filename + '.png';
        }

        if(extension.toLowerCase() === 'mp4') {
          this.keystone_marketing_download.type = 'video';
        } else {
          this.keystone_marketing_download.type = 'file';
        }

        this.filetype = uploadedFile.type;
        this.uploaded_file = uploadedFile;
      },
      fileRemovedFromDropZone(file) {
        this.filetype = null;
        this.uploaded_file = null;
        this.keystone_marketing_download.filename = null;
        this.keystone_marketing_download.thumbnail_url = null;
      },
      thumbnailFileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.'+extension, '');

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.thumbnailFileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: jpg, png, svg, gif, bmp',
          });
          return;
        }

        if (this.$refs.thumbnailFileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.thumbnailFileUploadDropzone.dropzone.removeFile(this.$refs.thumbnailFileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'keystone_marketing_downloads/uploaded_thumbs/'+ original_file_name + '_' + Date.now();
        this.thumbnail_upload.filename = filename + '.' + extension;

        if(extension.toLowerCase() === 'svg') {
          this.thumbnail_upload.thumbnail_url = this.thumbnail_upload.filename;
        } else {
          this.thumbnail_upload.thumbnail_url = filename + '.png';
        }

        this.thumbnail_upload.filetype = uploadedFile.type;
        this.thumbnail_upload_uploaded_file = uploadedFile;
      },
      thumbnailFileRemovedFromDropZone(file) {
        this.thumbnail_upload_uploaded_file = null;
        this.thumbnail_upload.filetype = null;
        this.thumbnail_upload.filename = null;
        this.thumbnail_upload.thumbnail_url = null;
      },
      save() {
        const validationErrors = Validate({
          name: this.keystone_marketing_download.name,
        }, {
          name: {
            presence: {
              allowEmpty: false,
            },
          },
        });

        if (validationErrors) {
          Swal.fire({
            title: 'Unable to save file',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        this.saving_file = true;

          if(this.uploaded_file !== null) {
            let form_data = new FormData(document.querySelector('#amazon_form'));
            form_data.append('file', this.uploaded_file);
            axios({
              method: 'post',
              url: this.$aws_upload_url,
              data: form_data,
              headers: {'Content-Type': 'multipart/form-data'}
            }).then(() => {
              this.saveThumbnailFile();
            });
          } else {
            this.saveThumbnailFile();
          }
      },
      saveThumbnailFile() {
        if(this.thumbnail_upload_uploaded_file !== null) {
          let thumbnail_form_data = new FormData(document.querySelector('#thumbnail_amazon_form'));
          thumbnail_form_data.append('file', this.thumbnail_upload_uploaded_file);
          axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: thumbnail_form_data,
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(() => {
            // if there's a custom thumbnail, replace the autogenerated thumbnail_url on the keystone_marketing_download
            this.keystone_marketing_download.thumbnail_url = this.thumbnail_upload.thumbnail_url;
            this.saveKeystoneMarketingDownload();
          });
        } else {
          this.saveKeystoneMarketingDownload();
        }
      },
      saveKeystoneMarketingDownload() {
        axios.post('/keystone-downloads/update',{
          keystone_marketing_download: this.keystone_marketing_download,
        }).then(() => {
          window.location.href = '/keystone-downloads';
        });
      },
      downloadItem(item_id) {
        axios.get( `/keystone-downloads/download-item/${item_id}`).then((response) => {
          window.location.href = response.data;
        });
      },
    },
  };
</script>
